@if(isChromeOrSafari !== undefined){
<section class="app__page h-screen">
  <section class="app__header-logo">
    <div>
      <a [routerLink]="['/']" class="">
        <img src="assets/images/logo.svg" alt="the logo in text showing kinnect beta" class="logo h-12" />
      </a>
    </div>
  </section>

  <section class="container-shadow translate-container min-w-[90vw] max-w-[1068px] h-[578px] flex items-center justify-center">
    <div class="verify_container flex flex-col items-center justify-center m-0">
      <img src="/assets/images/browser-not-supported.svg" alt="browser-not-supported" class="w-[260px] h-[260px] mb-[42px]" />

      <h1 class="font-bold text-3xl mb-6">Browser Not Supported!</h1>
      <p class="text-xl font-medium mb-6 text-center">Looks like you are using a browser that’s not supported by this website.</p>

      <p class="text-xl font-medium mb-6 flex items-center justify-center gap-3 flex-wrap">
        Please use
        <a
          href="https://www.apple.com/safari/"
          target="_blank"
          class="rounded-[30px] bg-[#EBF0FA] h-14 px-4 py-3 cursor-pointer no-underline hover:text-black"
        >
          <img src="/assets/images/safari-browser-logo.svg" alt="" />
          Safari</a
        >
        or
        <a
          href="https://www.google.com/chrome/?brand=JJTC&ds_kid=43700078658943277&gclsrc=aw.ds&gad_source=1&gclid=EAIaIQobChMI9PH15fGYjAMVDzbUAR0w6ww4EAAYASAAEgJ2pfD_BwE"
          target="_blank"
          class="rounded-[30px] bg-[#EBF0FA] h-14 px-4 py-3 cursor-pointer no-underline hover:text-black"
        >
          <img src="/assets/images/chrome-browser-logo.svg" alt="" />
          Google Chrome</a
        >
      </p>
    </div>
  </section>
</section>
}
